import * as echarts from "echarts";

let chartInstance = null;

export function renderDeviceWorkTimeTrend(el, labels, values) {
    if (!el) return;
    if (chartInstance) {
        chartInstance.dispose();
        chartInstance = null;
    }
    chartInstance = echarts.init(el);
    const option = {
        tooltip: {
            trigger: "axis",
            formatter: (params) => {
                const p = params?.[0];
                if (!p) return "";
                return `${p.name}<br/>合计工时：${p.value} h`;
            },
        },
        grid: {
            left: "3%",
            right: "3%",
            top: "12%",
            bottom: "8%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            boundaryGap: false,
            data: labels,
            axisLabel: {
                rotate: labels.length > 12 ? 45 : labels.length > 6 ? 30 : 0,
                fontSize: labels.length > 12 ? 11 : 12,
            },
        },
        yAxis: {
            type: "value",
            name: "小时",
            minInterval: 1,
        },
        series: [
            {
                name: "合计工时",
                type: "line",
                smooth: true,
                symbol: "circle",
                symbolSize: 8,
                lineStyle: { width: 2, color: "#1e6aed" },
                itemStyle: { color: "#1e6aed" },
                areaStyle: {
                    opacity: 0.15,
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "rgba(30, 106, 237, 0.35)" },
                        { offset: 1, color: "rgba(30, 106, 237, 0.02)" },
                    ]),
                },
                label: {
                    show: true,
                    position: "top",
                    formatter: "{c}h",
                },
                data: values,
            },
        ],
    };
    chartInstance.setOption(option);
}

export function resizeDeviceWorkTimeTrend() {
    chartInstance?.resize();
}

export function disposeDeviceWorkTimeTrend() {
    if (chartInstance) {
        chartInstance.dispose();
        chartInstance = null;
    }
}
